import { useState } from "react";
import { Button, Dropdown, Flex, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import { VectorWhiteIcon } from "@/shared/assets/svg/icons";
import { useDisclosure } from "@shared/lib/hooks";
import { DocstoreSections, getSelectedSectionFromParams } from "../../model";
import {
  DocstoreSectionFilters,
  DocstoreSectionTable,
  DocstoreSectionUploadModal,
  MassUploadModal,
} from "./ui";
import { FilterType } from "./ui/docstore-section-filters/hooks/use-filters";
import { DocstoreSectionPilotUpload } from "./ui/docstore-section-pilot-upload";
import "./docstore-section.scss";

export function DocstoreSection() {
  const [searchParams] = useSearchParams();
  const selectedSection = getSelectedSectionFromParams(searchParams);
  const [filters, setFilters] = useState<FilterType[]>([]);
  const [searchValue, setSearchValue] = useState("");

  const {
    isOpen: isUploadModalOpen,
    onOpen: onUploadModalOpen,
    onClose: onUploadModalClose,
  } = useDisclosure();

  const {
    isOpen: isMassUploadModalOpen,
    onOpen: onMassUploadModalOpen,
    onClose: onMassUploadModalClose,
  } = useDisclosure();

  const {
    isOpen: isPilotUploadModalOpen,
    onOpen: onPilotUploadModalOpen,
    onClose: onPilotUploadModalClose,
  } = useDisclosure();

  const handleFiltersChange = (
    newFilters: FilterType[],
    newSearchValue: string,
  ) => {
    setFilters(newFilters);
    setSearchValue(newSearchValue);
  };

  return (
    <Flex vertical className="sections">
      <Flex justify="space-between">
        <Typography.Title level={4} className="docstore-section-title">
          {
            DocstoreSections[selectedSection]
          }
        </Typography.Title>
        {DocstoreSections[selectedSection] !== DocstoreSections.NORMATIVE &&
          DocstoreSections[selectedSection] !== DocstoreSections.EXECUTIVE_DRAWING && (
            <Flex>
              <Dropdown
                trigger={["click"]}
                placement="bottomRight"
                menu={{
                  items: [
                    {
                      key: "local",
                      label: "Загрузить файл",
                      onClick: onUploadModalOpen,
                    },
                    {
                      key: "mass-upload",
                      label: "Массовая загрузка",
                      onClick: onMassUploadModalOpen,
                    },
                    {
                      key: "pilot",
                      label: "Загрузить из PILOT",
                      onClick: onPilotUploadModalOpen,
                    },
                  ],
                }}
              >
                <Button type="primary" className="upload-button">
                  Загрузить
                  <VectorWhiteIcon />
                </Button>
              </Dropdown>
            </Flex>
          )}
      </Flex>

      <DocstoreSectionFilters onFiltersChange={handleFiltersChange} />
      <DocstoreSectionTable filters={filters} searchValue={searchValue} />

      <DocstoreSectionUploadModal
        isModalOpen={isUploadModalOpen}
        handleOk={onUploadModalOpen}
        handleCancel={onUploadModalClose}
      />
      <MassUploadModal
        isModalOpen={isMassUploadModalOpen}
        handleCancel={onMassUploadModalClose}
      />
      <DocstoreSectionPilotUpload
        isModalOpen={isPilotUploadModalOpen}
        handleCancel={onPilotUploadModalClose}
      />
    </Flex>
  );
}
